module.exports = __webpack_public_path__ + "img/bg-home-spaceman-and-dog.b82450bf.svg";